package org.example.zone360.pages.players_Details

import org.example.zone360.components.debugPrintln

import org.example.zone360.pages.players_Details.playersInfo.PlayerInfo
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.stevdza.san.kotlinbs.models.ToastPlacement
import com.stevdza.san.kotlinbs.models.ToastStyle
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.isExporting
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowLeft
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.example.zone360.utils.getClubSeason
import org.example.zone360.utils.getProfile
import org.example.zone360.utils.getSinglePlayer
import kotlinx.browser.localStorage
import kotlinx.browser.window
import org.example.zone360.components.BSToastBasicCustom
import org.example.zone360.components.BSToastGroupCustom
import org.example.zone360.components.CommonDropdown
import org.example.zone360.components.showToast
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.DashboardChatState
import org.example.zone360.models.GetSentencesData
import org.example.zone360.models.GetSessionsData
import org.example.zone360.models.GetSinglePlayerData
import org.example.zone360.models.SummarizeAssessmentPayload
import org.example.zone360.pages.players_Details.assistAI.AssistAI
import org.example.zone360.pages.players_Details.assistAI.AssistAIOverlay
import org.example.zone360.pages.players_Details.assistAI.SubscriptionsPayment
import org.example.zone360.pages.players_Details.coachesRecommendation.CoachRecommendation
import org.example.zone360.pages.players_Details.playerRecentAssessment.PlayersRecentAssessment
import org.example.zone360.pages.players_Details.videosSection.VideosSection
import org.example.zone360.sections.DashboardHeaderSection
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.AppGlobal.Companion.seasonDataList
import org.example.zone360.utils.mediaManagerUtils.AudioManager
import org.example.zone360.utils.Res
import org.example.zone360.utils.SelectedData
import org.example.zone360.utils.SelectedLanguage
import org.example.zone360.utils.Strings
import org.example.zone360.utils.ToastID
import org.example.zone360.utils.injectChatAnimationStyles
import org.example.zone360.utils.injectMarkdownStyles
import org.example.zone360.utils.mediaManagerUtils.VideoManager
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.example.zone360.utils.summarizePlayerAssessment
import kotlin.coroutines.cancellation.CancellationException


@Page("/player-details")
@Composable
fun PlayersDetails() {
    val ctx = rememberPageContext()
    if (ctx.isExporting) return

    val scope = rememberCoroutineScope()
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()

    var getPlayerInfo by remember { mutableStateOf(GetSinglePlayerData()) }
    var message by remember { mutableStateOf("") }
    var summary by remember { mutableStateOf("") }
    val userVideos = remember { mutableStateListOf<String>() }
    var showOverlay by remember { mutableStateOf(false) }
    var subscriptionPopup by remember { mutableStateOf(false) }
    var noScroll by remember { mutableStateOf(false) }
    var isChatOpen by remember { mutableStateOf(false) }
    val chatState = remember {
        DashboardChatState()
    }
    LaunchedEffect(Unit) {
        injectMarkdownStyles()
        injectChatAnimationStyles()
    }
    val params = ctx.route.params
    val userId = if (AppGlobal.userData.role == Strings.PLAYER) {
        params["userId"] ?: AppGlobal.userData.uid
    } else {
        params["userId"]
    }

    if (userId.isNullOrBlank() || (AppGlobal.userData.payment.checkout.status != Strings.PAID && AppGlobal.userData.role == Strings.ADMIN)) {
        LaunchedEffect(Unit) { ctx.router.navigateTo("/home") }
        return
    }

    val data = localStorage.getItem("userData")
    if (data == null) {
        ctx.router.navigateTo("/login")
        return
    }

    if (AppGlobal.userData.organization == "null" || AppGlobal.userData.organization.isEmpty()) {
        ctx.router.navigateTo("/coach-details?userId=${AppGlobal.userData.uid}")
        return
    }

    var languageType by remember { mutableStateOf(SelectedLanguage.English.name) }
    var sessionDataType by remember { mutableStateOf(SelectedData.Training.name) }

    val selectedLanguage by remember {
        mutableStateOf(
            when (localStorage.getItem("selectedLanguage")) {
                "it" -> SelectedLanguage.Italian
                else -> SelectedLanguage.English
            }
        )
    }
    val selectedDataType by remember {
        mutableStateOf(
            when (localStorage.getItem("selectedDataType")) {
                Strings.MATCH -> SelectedData.Matches
                else -> SelectedData.Training
            }
        )
    }

    val getSessions = remember { mutableStateListOf<GetSessionsData>() }
    val tagData = remember { mutableStateListOf<GetSentencesData>() }


    val playerSeasonIds = AppGlobal.userData.seasons.map { it.seasonID }
    val playerSeasons = seasonDataList.filter { it.id in playerSeasonIds }
    var isDashboardExpanded by remember { mutableStateOf(AppGlobal.isPlayerChatbotExpanded) }

    // Save to AppGlobal when changed
    LaunchedEffect(isDashboardExpanded) {
        AppGlobal.isPlayerChatbotExpanded = isDashboardExpanded
    }
// Start with empty — will be set after seasonDataList loads
    var selectedSeasonDisplay by remember { mutableStateOf("") }

    var selectedSeasonId by remember {
        mutableStateOf(
            if (AppGlobal.userData.role == Strings.PLAYER) {
                val playerSeasonIds = AppGlobal.userData.seasons.map { it.seasonID }
                val currentId = AppGlobal.userData.season.id
                if (currentId in playerSeasonIds) currentId
                else playerSeasonIds.firstOrNull() ?: ""
            } else {
                // Read from localStorage first, fall back to AppGlobal
                localStorage.getItem("selectedSeasonId") ?: AppGlobal.selectedSeasonId
            }
        )
    }
    if (AppGlobal.userData.role == Strings.PLAYER) {
        LaunchedEffect(AppGlobal.seasonUpdate) {
            try {
                val seasonData = getClubSeason(
                    organization = AppGlobal.userData.organization,
                    seasonID = localStorage.getItem("selectedSeasonId") ?: ""
                )
                seasonDataList.clear()
                seasonDataList.addAll(seasonData.data)

                // Now resolve display name after list is ready
                selectedSeasonDisplay = if (AppGlobal.userData.role == Strings.PLAYER) {
                    seasonDataList
                        .firstOrNull { it.id == selectedSeasonId }?.name
                        ?: selectedSeasonId // fallback to id if name not found
                } else {
                    AppGlobal.selectedSeason
                }

            } catch (ce: CancellationException) {
                throw ce
            } catch (e: Exception) {
                debugPrintln("Failed to fetch season data: ${e.message}")
            }
        }
    }

    // Keep AppGlobal in sync so other parts of the app stay consistent
    LaunchedEffect(selectedSeasonId, selectedSeasonDisplay) {
        AppGlobal.selectedSeasonId = selectedSeasonId
        AppGlobal.selectedSeason = selectedSeasonDisplay.ifEmpty {
            localStorage.getItem("selectedSeason") ?: ""
        }
    }
    DisposableEffect(Unit) {
        onDispose {
            AudioManager.releaseAll()
            VideoManager.releaseAll()
        }
    }

    // Re-fire all data APIs whenever the season changes (or on first load)
    LaunchedEffect(selectedSeasonId, AppGlobal.refreshPlayerProfile) {
        try {
            val getPlayerResponse = getSinglePlayer(
                domainType = "soccer",
                language = "en",
                userID = userId,
                organization = AppGlobal.userData.organization,
                seasonID = selectedSeasonId
            )
            getPlayerInfo = getPlayerResponse.data
            userVideos.clear()
            userVideos.addAll(getPlayerResponse.data.userVideos.map { "${Res.Video.base_Video_URL}$it" })
        } catch (ce: CancellationException) {
            throw ce
        } catch (e: Exception) {
            message = "Failed to fetch player data"
            showToast(ToastID.ERROR)
        }

        try {
            val payload = SummarizeAssessmentPayload(
                organization = AppGlobal.userData.organization,
                playerID = getPlayerInfo.uid,
                seasonID = selectedSeasonId,
                language = "en",
                domainType = "soccer"
            )
            val response = summarizePlayerAssessment(payload)
            if (!response.summary.isNullOrBlank()) {
                summary = response.summary
            } else if (!response.error.isNullOrBlank()) {
                message = response.error
                showToast(ToastID.ERROR)
            } else if (response.summary.isNullOrBlank() && !response.message.isNullOrBlank()) {
                summary = response.message
            }
        } catch (ce: CancellationException) {
            throw ce
        } catch (_: Exception) {
            debugPrintln("Failed to fetch summary")
        }
    }

    LaunchedEffect(AppGlobal.refreshGetProfileInPlayer) {
        if (AppGlobal.refreshGetProfileInPlayer.isNotEmpty()) {
            try {
                val profileResponse = getProfile(
                    organization = AppGlobal.userData.organization,
                    userID = AppGlobal.userData.uid,
                    seasonID = selectedSeasonId
                )
                AppGlobal.userData = profileResponse.data
            } catch (ce: CancellationException) {
                throw ce
            } catch (e: Exception) {
                debugPrintln("Failed to fetch profile: ${e.message}")
            }
        }
    }

    LaunchedEffect(Unit, selectedSeasonId) {
        if (AppGlobal.userData.role == Strings.PLAYER) {
            try {
                val profileResponse = getProfile(
                    organization = AppGlobal.userData.organization,
                    userID = AppGlobal.userData.uid,
                    seasonID = selectedSeasonId
                )
                AppGlobal.userData = profileResponse.data
            } catch (ce: CancellationException) {
                throw ce
            } catch (e: Exception) {
                debugPrintln("Failed to fetch profile: ${e.message}")
            }
        }
    }

    LaunchedEffect(selectedDataType, selectedLanguage, selectedSeasonId) {
        val languageCode = when (selectedLanguage) {
            SelectedLanguage.English -> "en"
            SelectedLanguage.Italian -> "it"
        }
        languageType = languageCode
        localStorage.setItem("selectedLanguage", languageCode)

        val sessionType = when (selectedDataType) {
            SelectedData.Training -> Strings.TRAINING
            SelectedData.Matches -> Strings.MATCH
        }
        sessionDataType = sessionType
        localStorage.setItem("selectedDataType", sessionType)
    }

    if (subscriptionPopup) {
        SubscriptionsPayment(
            onDialogDismiss = { subscriptionPopup = false },
            sitePalette = sitePalette,
            breakpoint = breakpoint,
            getPlayerInfo = getPlayerInfo,
            toastMessage = { message = it }
        )
    }

    Box(Modifier.fillMaxSize())
    {
        BSToastGroupCustom(placement = ToastPlacement.TopRight) {
            BSToastBasicCustom(
                id = "toastSuccess",
                text = message,
                style = ToastStyle.Success,
                autoHide = true,
                closeButtonDark = false,
                onCloseClick = {}
            )
            BSToastBasicCustom(
                id = "toastError",
                text = message,
                style = ToastStyle.Danger,
                autoHide = true,
                closeButtonDark = false,
                onCloseClick = {}
            )
        }

        Column(modifier = Modifier.fillMaxSize().backgroundColor(sitePalette.bodyBackground.rgb)) {
            DashboardHeaderSection(
                clubButton = AppGlobal.userData.role != Strings.PLAYER,
                coachButton = AppGlobal.userData.role == Strings.COACH,
                toastMessage = { message = it }
            )
            Column(
                modifier = Modifier.fillMaxHeight()
                    .fillMaxWidth(if (window.screen.width > 1800) 1700.px else 100.percent)
                    .padding(leftRight = if (breakpoint >= Breakpoint.LG) 44.px else if (breakpoint >= Breakpoint.MD) 20.px else 10.px)
                    .align(Alignment.CenterHorizontally),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Row(
                    modifier = Modifier.fillMaxWidth().margin(top = 30.px, bottom = 10.px),
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    if (AppGlobal.userData.role != Strings.PLAYER) {
                        FaArrowLeft(
                            modifier = Modifier
                                .onClick {
                                    if (window.history.length > 1) window.history.back()
                                    else ctx.router.navigateTo("/home")
                                }
                                .cursor(Cursor.Pointer)
                        )
                    }
                    FieldTitleTextNormalSimple(
                        text = "Players Details",
                        fontWeight = 500,
                        fontSize = 16.px,
                        marginLeft = 15.px
                    )
                    Spacer()
                    if (AppGlobal.userData.role == Strings.PLAYER) {
                        Row(
                            modifier = Modifier
                                .margin(top = if (breakpoint < Breakpoint.MD) 10.px else 0.px)
                                .width(
                                    if (breakpoint > Breakpoint.LG) 14.percent
                                    else if (breakpoint >= Breakpoint.LG) 18.percent
                                    else if (breakpoint >= Breakpoint.MD) 24.percent
                                    else 54.percent
                                )
                        ) {
                            CommonDropdown(
                                data = playerSeasons.map { it.name }, // ← show name
                                onSelect = { selectedName ->
                                    // Find the id matching the selected name
                                    val matched =
                                        playerSeasons.firstOrNull { it.name == selectedName }
                                    if (matched != null) {
                                        selectedSeasonDisplay = matched.name  // display name
                                        selectedSeasonId = matched.id         // send id in payload
                                    } else {
                                        selectedSeasonDisplay = Strings.DEFAULT_SEASON
                                        selectedSeasonId = ""
                                    }
                                },
                                selectedItem = selectedSeasonDisplay,
                                height = 38.px,
                                width = 100.percent
                            )
                        }
                    }
                }

                Column(
                    modifier = Modifier.fillMaxWidth()
                        .borderRadius(16.px)
                        .padding(
                            topBottom = if (breakpoint >= Breakpoint.MD) 16.px else 10.px,
                            leftRight = if (breakpoint >= Breakpoint.MD) 24.px else 10.px
                        )
                        .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                ) {
                    Row(
                        modifier = Modifier.fillMaxWidth().margin(topBottom = 10.px)
                            .padding(leftRight = if (breakpoint <= Breakpoint.MD) 0.px else 60.px)
                            .flexWrap(FlexWrap.Wrap),
                        horizontalArrangement = Arrangement.SpaceBetween
                    ) {
                        Column(
                            modifier = Modifier
                                .width(
                                    if (breakpoint >= Breakpoint.LG) 100.percent
                                    else if (breakpoint > Breakpoint.MD) 54.percent
                                    else 100.percent
                                )
                                .gap(24.px)
                        ) {
                            PlayerInfo(
                                breakpoint = breakpoint,
                                sitePalette = sitePalette,
                                userId = userId,
                                getPlayerInfo1 = getPlayerInfo,
                                updatePlayerInfo = { getPlayerInfo = it },
                                toastMessageCall = { message = it },
                                seasonId = selectedSeasonId
                            )
                            AssistAI(
                                onDismiss = { isChatOpen = false },
                                toastMessage = { message = it},
                                breakpoint = breakpoint,
                                sitePalette = sitePalette,
                                userId = userId,
                                showOverlay = showOverlay,
                                showOverlayChange = { showOverlay = it },
                                selectedSessionType = selectedDataType,
                                selectedLanguage = selectedLanguage,
                                getPlayerInfo = getPlayerInfo,
                                subscriptionPopup = {
                                    subscriptionPopup = it
                                    noScroll = it
                                },
                                toastMessageCall = { message = it },
                                sessionData = getSessions,
                                taggedList = tagData,
                                isChatOpen = false,                                  // inline copy never renders "open"; the overlay below handles that
                                onExpandToggle = {
                                    isChatOpen = true
                                },               // clicking the expand-arrow opens the fullscreen overlay
                                isDashboardExpanded = isDashboardExpanded,
                                onDashboardExpandToggle = {
                                    isDashboardExpanded = !isDashboardExpanded
                                    AppGlobal.isPlayerChatbotExpanded = !isDashboardExpanded
                                },
                                scrollContainerId = Res.Id.playerChatBot,
                                messageInputId = Res.Id.playerMessageInputField,
                                chatMessages = chatState
                            )
                            PlayersRecentAssessment(
                                breakpoint,
                                sitePalette,
                                userId,
                                message = { message = it },
                                getPlayerInfo = getPlayerInfo,
                                setPlayerInfo = { updated -> getPlayerInfo = updated },
                                toastMessageCall = { message = it },
                                noOverFlow = {
                                    noScroll = it
                                },
                                sessionData = {
                                    getSessions.clear()
                                    getSessions.addAll(it)
                                },
                                seasonId = selectedSeasonId
                            )
                            CoachRecommendation(
                                breakpoint, sitePalette, getPlayerInfo,
                                toastMessage = { message = it },
                                summary = summary
                            )
                            VideosSection(
                                breakpoint,
                                sitePalette,
                                userId,
                                message = { message = it },
                                userVideos,
                                tagData = {
                                    tagData.clear()
                                    tagData.addAll(it)
                                },
                                seasonId = selectedSeasonId
                            )
                        }

                        Column(
                            modifier = Modifier
                                .width(
                                    if (breakpoint >= Breakpoint.LG) 31.percent
                                    else if (breakpoint > Breakpoint.MD) 44.percent
                                    else 100.percent
                                )
                                .gap(24.px)
                        ) { }
                    }
                }
            }
        }

//        Box(
//            modifier = Modifier
//                .position(Position.Fixed)
//                .bottom(50.px)
//                .right(if (breakpoint <= Breakpoint.MD) 0.px else 70.px)
//                .zIndex(999),
//            contentAlignment = Alignment.CenterEnd
//        )
//        {
//            Box(
//                modifier = Modifier
//                    .transform {
//                        translateY(if (isChatOpen) 0.px else 20.px)
//                        scaleY(if (isChatOpen) 1f else 0.95f)
//                    }
//                    .opacity(if (isChatOpen) 1f else 0f)
//                    .transformOrigin(TransformOrigin.BottomRight)
//                    .transition(
//                        Transition.of(
//                            TransitionProperty.All,
//                            300.ms,
//                            AnimationTimingFunction.EaseInOut
//                        )
//                    )
//            ) {
//                if (isChatOpen) {
//                    Box(
//                        modifier = Modifier
//                            .height(if (breakpoint < Breakpoint.XL) 623.px else if (window.screen.width < 1650) 750.px else 100.percent)
//                            .width(if (breakpoint < Breakpoint.MD) 100.percent else 480.px)
//                            .overflow(if (window.screen.width in 320..1650) Overflow.Auto else Overflow.Hidden)
//                            .borderRadius(12.px)
//                            .padding(leftRight = 10.px)
//                    ) {
//                        AssistAI(
//                            onDismiss = { isChatOpen = false },
//                            breakpoint = breakpoint,
//                            sitePalette = sitePalette,
//                            userId = userId,
//                            showOverlay = showOverlay,
//                            showOverlayChange = { showOverlay = it },
//                            selectedSessionType = selectedDataType,
//                            selectedLanguage = selectedLanguage,
//                            getPlayerInfo = getPlayerInfo,
//                            subscriptionPopup = {
//                                subscriptionPopup = it
//                                noScroll = it
//                            },
//                            toastMessageCall = { message = it },
//                            sessionData = getSessions,
//                            taggedList = tagData
//                        )
//                    }
//                }
//            }
//            if (!isChatOpen) {
//                Box(
//                    modifier = Modifier
//                        .size(55.px)
//                        .backgroundColor(sitePalette.primary.rgb)
//                        .borderRadius(100.percent)
//                        .cursor(Cursor.Pointer)
//                        .position(Position.Relative)
//                        .onClick { isChatOpen = true },
//                    contentAlignment = Alignment.Center
//                ) {
//                    Image(
//                        src = Res.Images.assistAi,
//                        modifier = Modifier
//                            .fillMaxSize()
//                            .borderRadius(100.percent)
//                            .cursor(Cursor.Pointer)
//                            .onClick { isChatOpen = true }
//                    )
//                    Box(
//                        modifier = Modifier
//                            .size(12.px)
//                            .backgroundColor(Palette.GreenShadeColor.rgbLight)
//                            .borderRadius(100.percent)
//                            .position(Position.Absolute)
//                            .bottom(45.px)
//                            .right(4.px)
//                    )
//                }
//            }
//        }
    }
    AssistAIOverlay(
        breakpoint = breakpoint,
        sitePalette = sitePalette,
        isChatOpen = isChatOpen,
        onDismiss = { isChatOpen = false },
        userId = userId,
        getPlayerInfo = getPlayerInfo,
        selectedSessionType = selectedDataType,
        selectedLanguage = selectedLanguage,
        sessionData = getSessions,
        taggedList = tagData,
        showOverlay = showOverlay,
        showOverlayChange = { showOverlay = it },
        subscriptionPopup = {
            subscriptionPopup = it
            noScroll = it
        },
        toastMessageCall = { message = it },
        chatMessages = chatState
    )
}
